import firebase from 'firebase'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

var firebaseConfig = {
    apiKey: "AIzaSyAQMuF4XPuhsq8NL_940ua1CTN7nAN38AQ",
    authDomain: "apps-bibles-direct-co-uk.firebaseapp.com",
    databaseURL: "https://apps-bibles-direct-co-uk.firebaseio.com",
    projectId: "apps-bibles-direct-co-uk",
    storageBucket: "apps-bibles-direct-co-uk.appspot.com",
    messagingSenderId: "614425714500",
    appId: "1:614425714500:web:0ef097f695a6fdc8a2c111",
    measurementId: "G-QVFQ155J9H"
}

firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()

var urls = {}

db.collection('links').onSnapshot(
    (linksCollection) => {
        linksCollection.forEach((link) => {
            let linkData = link.data()
            urls[link.id] = linkData.url
        })
    },
    (error) => {
        console.log(`Error loading links: ${error}`)
    }
)

export const links = urls

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
